import React from "react";
import { TextField } from "@material-ui/core";
import { Currency } from "./useCurrencies";

type Props = {
  name: string;
  value: string | undefined;
  onChange: React.ChangeEventHandler<HTMLInputElement>;
  currencies?: Currency[];
  loading?: boolean;
  label?: string;
};

const CurrencySelect: React.FC<Props> = ({
  name,
  value,
  onChange,
  currencies,
  loading,
  label = "Currency",
}) => (
  <TextField
    fullWidth
    select
    name={name}
    label={label}
    value={value ?? ""}
    onChange={onChange}
    SelectProps={{ native: true }}
  >
    <option value="" disabled>
      {loading ? "Loading..." : "Select currency"}
    </option>
    {currencies?.map((c) => (
      <option key={c.id} value={c.id}>
        {c.isoCode}
        {c.name ? ` — ${c.name}` : ""}
      </option>
    ))}
  </TextField>
);

export default CurrencySelect;
